'use client'
import React from 'react'
import Loader from './Loader'

interface Props {
  onClick?: () => void
  icon: JSX.Element
  active?: boolean
}

const IconButton = ({ onClick, icon, active = false }: Props) => {
  return (
    <button
      onClick={onClick}
      className={`border-slateGray border font-sans text-center text-16 md:text-18 h-[3.5rem]
                        flex items-center justify-center rounded-lg p-2 px-4 ${
                          active ? 'bg-slateGray text-white' : 'bg-white text-slateGray'
                        }`}>
      <div className="w-full h-full">{icon}</div>
    </button>
  )
}

export default IconButton
